export * from './calendar.model';
export { CalendarModal } from "./components/calendar.modal";
export { CalendarWeekComponent } from "./components/calendar-week.component";
export { MonthComponent } from "./components/month.component";
export { CalendarComponent } from "./components/calendar.component";
export { CalendarModule } from './calendar.module';
export { CalendarController } from './calendar.controller';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ion2-calendar/dist/index.js
// module id = 446
// module chunks = 73